module.exports = __webpack_public_path__ + "main-7ba52c85db8f3132b610.svg";